module.exports = __webpack_public_path__ + "static/media/star-line.63069be2.svg";